@if (modeNamesOfWidget().length !== 1) {
  <mat-expansion-panel class="filter-mode-selection-and-ordering-panel" expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="me-2 material-icons-outlined">source</mat-icon
        >{{ 'page.widgetContent.addEditDialog.contextScope' | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div cdkDropList cdkScrollable (cdkDropListDropped)="drop($event)">
      @for (mode of filterModeOrder()(); track mode) {
        <div class="d-flex align-items-center" cdkDrag [style.overflow]="'hidden'">
          <mat-icon class="drag-indicator">drag_indicator</mat-icon>
          <mat-checkbox checked (change)="uncheck(mode)">{{ 'filterModeName.' + mode | translate }}</mat-checkbox>
        </div>
      }
    </div>

    @for (mode of uncheckedRows(); track mode) {
      <div class="unchecked-row">
        <mat-checkbox (change)="check(mode)">{{ 'filterModeName.' + mode | translate }}</mat-checkbox>
      </div>
    }
  </mat-expansion-panel>
}
